import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function Checkout(){
    const { items, totalPrice, clearCart } = useCart();
    const navigate = useNavigate();
    const handleConfirm = _=>{
        alert(`Order placed! Total $${totalPrice.toFixed(2)}`);
        clearCart();
        navigate("/");
    };

    if(items.length === 0){
        return <div
            className="container"
        >
            <h3>Your cart is empty.</h3>
            <Link
                className="btn btn-primary mt-3"
                to="/"
            >Back to Shop</Link>

        </div>;
    }

    return <div
        className="container"
    >
        <h2>Checkout</h2>
        <ul
            className="list-group mb-4"
        >
            {items.map(i=><li
                key={i.id}
                className="list-group-item d-flex justify-content-between"
            >
                <span>{i.name} x {i.qty}</span>
                <span>${(i.price * i.qty).toFixed(2)}</span>
            </li>)}
        </ul>
        <h4
            className="btn btn-success me-2"
            onClick={handleConfirm}
        >Confirm Order</h4>
        <Link
            className="btn btn-outline-secondary"
            to="/cart"
        >Back to Cart</Link>
    </div>;
}